module.exports = __webpack_public_path__ + "img/Card-Winners.3081e040.png";